module.exports = __webpack_public_path__ + "static/media/my-referrals-icon-active.9014ba61.svg";